import type { FaireProductEntity } from "../../entity_types/product";

export const p_uyy8yrgvax: FaireProductEntity = {
  token: "p_uyy8yrgvax",
  type: "product",
  name: "Stupid Dishes Swedish Dishcloth",
  brandToken: "b_a7kevhkvzk",
  brandName: "Ecologie",
  imageUrl:
    "https://cdn.faire.com/fastly/b6afb058b40704c4291393bc7bfd2fb8c5d31a8f61bbed007777ba31b7f1f793.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/b22e4146c032e1b68f47a35a8373f6ae227e283ac406bc2176ac52db7b44c34b.jpeg",
    "https://cdn.faire.com/fastly/15e1f5997c267da41ce018cc036c09f60aa1c93e0f598e7b401f96a50d667ca2.jpeg",
    "https://cdn.faire.com/fastly/01ecf51b8e99982da7003f15cf4e72efa167608122bbb9c49f436e991a1989c9.jpeg",
    "https://cdn.faire.com/fastly/fa0d4eb58d0200951de6bde340ff2e669fa1112a93463ff1a5fbe3485c46870c.jpeg",
    "https://cdn.faire.com/fastly/cccced46f85bcd521a56659e55f5b8d8d8bbb89cb4247e95ca3333a93094f49e.jpeg",
  ],
  priceDollars: 3.25,
  description:
    "Wipe spills from the countertop big or small. Multitasking Swedish dishcloths are compostable cellulose sponge cloths that tackle any household jobs. Plus, it's perfectly safe to use them with a full range of cleaning products and wash them over 200 times. Swedish dishcloths are versatile, super-absorbent, reusable cleaning cloths that take on the tasks of sponge, dishcloth, and paper towel. Count on it for just about everything.",
  tags: [],
  msrpDollars: 6.5,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:54:45.858Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
